// Ayudas del editor de reglas de comisión; las comunes salen de Lifecycle.

export const RULE_HELP = {
    name: 'El nombre con el que el vendedor y tú reconocen la regla.',
    description: 'Cómo le explicas la regla al vendedor.',
    countBy: 'Si la regla cuenta y paga por pieza vendida o por venta completa.',
    saleBonus: 'Lo que gana el vendedor por cada pieza o venta en el alcance.',
    thresholdBonus: 'Bono único por corte cuando el vendedor cumple la condición.',
    multiplier: 'Multiplica lo ganado en el corte cuando se cumple la condición.',
    couponBonus: 'Lo que gana el vendedor por cada cupón de crédito pagado.',
    payTiming: 'En qué momento se deposita lo ganado.',
    advance: 'Porcentaje que se paga al registrar la venta; el resto, al cierre.',
    metric: 'Qué se mide para decidir si la regla dispara. Sin condición, siempre aplica.',
    operator: 'Cómo se compara la métrica contra el valor.',
    value: 'El valor contra el que se compara la métrica.',
    minSample: 'Créditos mínimos para evaluar la regla; evita premiar o castigar con poca cartera.',
    scopeType: 'Tipos de producto que cuentan para la regla.',
    scopeTier: 'Gamas de producto que cuentan para la regla.',
    scopeSku: 'Productos concretos que cuentan para la regla.',
    scopeStore: 'Tiendas cuyas ventas cuentan para la regla.',
    clawback: 'Si la venta se cancela o se devuelve dentro de estos días, se descuenta lo pagado.',
} as const;
